import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Close from "@material-ui/icons/Close";
// import Assignment from "@material-ui/icons/Assignment";
import Face from "@material-ui/icons/Face";
import Phone from "@material-ui/icons/Phone";
import Edit from "@material-ui/icons/Edit";
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// import Card from "components/Card/Card.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class AddContactSecondData extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  // }


  render() {
    const { classes, propertyData } = this.props;
    return (
            <div>
              <GridContainer>

                <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
                  <CustomInput
                    labelText="Id number"
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses
                    }}

                  />
                  <CustomInput
                    labelText="Vat number"
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses
                    }}

                  />

                </GridItem>
                <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>

                <FormControl id="id_number_type" className={classes.formControl} margin="normal">
                  <InputLabel htmlFor="currency">Type</InputLabel>
                  <Select
                    native={true}
                    value='{propertyData.id_number_type.value}'
                    onChange={(e) => this.props.changeHandler(e)}
                    id="id_number_type"
                    inputProps={{
                      name: 'id_number_type',
                      id: 'id_number_type',
                    }}
                  >

                  <option value="NIE">NIE</option>
                  <option value="Passport">Passport</option>
                  <option value="NIF">NIF</option>
                  </Select>
                </FormControl>
                    <CustomInput
                      labelText="Vat country"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}

                    />

                </GridItem>

              </GridContainer>

              <GridContainer>
                <GridItem xs={1} sm={1} md={1} className={classes.mrAuto}>
                </GridItem>
                <GridItem xs={10} sm={10} md={10} className={classes.mrAuto}>
                <CustomInput
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses
                  }}
                  inputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        className={classes.inputAdornment}
                      >
                        <Edit className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                    placeholder: "Notes"
                  }}
                />
                </GridItem>
                <GridItem xs={1} sm={1} md={1} className={classes.mrAuto}>
                </GridItem>

              </GridContainer>

            </div>

    );
  }
}

export default withStyles(javascriptStyles)(AddContactSecondData);
